import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { createGuid } from 'helpers/GuidHelper';

const ContextMenu = ({ button, children }) => {
    const [menuAnchorElement, setMenuAnchorElement] = useState(undefined);
    const [id] = useState(`menu-${createGuid()}`);

    const handleOpenMenu = event => {
        setMenuAnchorElement(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuAnchorElement(undefined);
    };

    return (
        <>
            <Button aria-controls={id} aria-haspopup="true" onClick={handleOpenMenu}>
                {button}
            </Button>
            <Menu
                id={id}
                anchorEl={menuAnchorElement}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                open={Boolean(menuAnchorElement)}
                onClose={handleCloseMenu}
                getContentAnchorEl={undefined}
            >
                {children({ handleCloseMenu })}
            </Menu>
        </>
    );
};

ContextMenu.propTypes = {
    button: PropTypes.node.isRequired,
    children: PropTypes.func.isRequired
};

export default ContextMenu;
